export enum Color {
  Highlight = 'yellow',
  ErrorBackground = '#f20000',
  MessageAnchor = '#0000FF',
  MessageErrorBackground = '#FFFFFF',
}
